import { render } from "./LaboratorioDetalle.vue?vue&type=template&id=52ae0206"
import script from "./LaboratorioDetalle.vue?vue&type=script&lang=js"
export * from "./LaboratorioDetalle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__